import styled from '@emotion/styled';
import { contractService } from 'store/slices/contractSlice';
import {
  CONTENT_PRYMARY_DARK,
  CONTENT_PRYMARY_LIGHT,
  CONTENT_SECONDARY_LIGHT,
} from 'constants/designSystem';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/config';

type Props = {};

const MintInteraction = (props: Props) => {
  const isLoggedIn = useAppSelector((state) => state.wallet.isLoggedIn);
  const salesInfo = useAppSelector((state) => state.contract.salesInfo);
  const isLoading = useAppSelector((state) => state.contract.isLoading);
  const { mintLimitPerBlock, mintPrice, isPublicMintEnabled } = salesInfo;
  const dispatch = useAppDispatch();

  const isMobile = useAppSelector((state) => state.global.isMobile);
  const [mintAmount, setMintAmount] = useState(1);

  const onClickPublicMint = () => {
    if (isMobile) {
      dispatch(contractService.publicMintWithEthers(mintAmount));
    } else {
      dispatch(contractService.publicMint(mintAmount));
    }
  };

  const addMintAmount = () => {
    setMintAmount((prev) => {
      if (prev === mintLimitPerBlock) {
        return prev;
      }

      return prev + 1;
    });
  };

  const subMintAmount = () => {
    setMintAmount((prev) => {
      if (prev > 1) {
        return prev - 1;
      } else {
        return prev;
      }
    });
  };

  return (
    <MintingInteractionWrapper>
      <MintingInfoSubTitle>
        민팅가격
        <Price>
          <KlaytnLogo src='https://stakingcrypto.info/static/assets/coins/klaytn-logo.png' />
          {mintPrice * mintAmount} KLAY
        </Price>
      </MintingInfoSubTitle>
      <SpaceBetween>
        <MintingInfoSubTitle>민팅수량</MintingInfoSubTitle>
        <div>
          <MinusButton onClick={subMintAmount} />
          <MintAmount>{mintAmount}</MintAmount>
          <PlusButton onClick={addMintAmount} />
        </div>
      </SpaceBetween>
      <MintButton
        disabled={!isPublicMintEnabled || !isLoggedIn || isLoading}
        onClick={() => onClickPublicMint()}
      >
        {isLoggedIn ? 'GO TO MINTING' : 'REQUIRED CONNECT WALLET'}
      </MintButton>
    </MintingInteractionWrapper>
  );
};

const MintingInteractionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MintingInfoSubTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #5b5b5b;
`;

const Price = styled.span`
  font-size: 18px;
  color: var(--bg-color);
  font-weight: 900;
`;

const KlaytnLogo = styled.img`
  margin: 0 8px;
  width: 18px;
  height: 18px;
  vertical-align: middle;
`;

const AmountButton = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  background-color: #4d5ced;
  color: #ffffff;
  border-radius: 50%;
  padding: 4px;
  line-height: 1;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background-color: #f7aedc;
  }
`;

const MinusButton = styled(AmountButton)`
  &::before {
    content: '━';
  }

  margin-right: 18px;
`;
const PlusButton = styled(AmountButton)`
  &::before {
    content: '╋';
  }

  margin-left: 18px;
`;

const MintAmount = styled.span`
  color: var(--bg-color);
  font-weight: 900;
  vertical-align: middle;
`;

const MintButton = styled.button`
  width: 100%;
  text-align: center;
  background-color: var(--bg-color);
  border: none;
  padding: 12px 0;
  color: #ffffff;
  font-size: 16px;
  margin-top: 16px;
  line-height: 1.1;
  font-weight: 600;
  cursor: pointer;

  &:hover:enabled {
    background-color: #f7aedc;
  }

  &:disabled {
    cursor: default;
    background-color: darkgray;
    opacity: 0.7;
  }
`;

export default MintInteraction;
